<template>
  <div class="list-group">
    <button
      type="button"
      @click.prevent="onSelect('efectivo')"
      class="list-group-item"
      :class="{ active: value.type === 'efectivo' }"
      v-if="includesMethod('efectivo')"
    >
      <div class="d-flex mb-2">
        <i class="material-icons mr-2">
          {{ value.type === 'efectivo' ? 'radio_button_checked' : 'radio_button_unchecked' }}
        </i>
        <span>EFECTIVO</span>
      </div>
    </button>
    <button
      type="button"
      @click.prevent="onSelect('pos', typeCard, numberPost, detailPayment)"
      class="list-group-item"
      :class="{ active: value.type === 'pos' }"
      :disabled="!couponFree"
      v-if="includesMethod('pos')"
    >
      <div class="d-flex mb-2">
        <i class="material-icons mr-2">
          {{ value.type === 'pos' ? 'radio_button_checked' : 'radio_button_unchecked' }}
        </i>
        <span>POS</span>
      </div>
      <div class="btn-dev">
        <select v-model="detailPayment" id="select-banks" class="form-control mr-4" required>
          <option v-for="i in DETAIL_PAYMENT" :key="i" :value="i">
            {{ i.toUpperCase() }}
          </option>
        </select>
        <select v-model="typeCard" id="select-type-cards" class="form-control mr-4" required>
          <option v-for="i in CARD_TYPES" :key="i" :value="i">
            {{ i }}
          </option>
        </select>
        <input
          v-model="numberPost"
          @input="onSelect('pos', typeCard, numberPost, detailPayment)"
          type="text"
          class="form-control"
          placeholder="Código de referencia"
        />
      </div>
    </button>
    <button
      type="button"
      @click.prevent="onSelect('pos', 'mastercard', mastercard)"
      class="list-group-item"
      :class="{ active: value.card === 'mastercard' }"
      :disabled="!couponFree"
      v-if="includesMethod('mastercard')"
    >
      <div class="d-flex mb-2">
        <i class="material-icons mr-2">
          {{ value.card === 'mastercard' ? 'radio_button_checked' : 'radio_button_unchecked' }}
        </i>
        <span>MASTERCARD</span>
      </div>
      <input
        v-model="mastercard"
        @input="onSelect('pos', 'mastercard', mastercard)"
        type="text"
        class="form-control"
        placeholder="código pos mastercard"
      />
    </button>
    <button
      type="button"
      @click.prevent="onSelect('transferencia', bank, numbertransfer)"
      class="list-group-item"
      :class="{ active: value.type === 'transferencia' }"
      :disabled="!couponFree"
      v-if="includesMethod('transferencia')"
    >
      <div class="d-flex mb-2">
        <i class="material-icons mr-2">
          {{ value.type === 'transferencia' ? 'radio_button_checked' : 'radio_button_unchecked' }}
        </i>
        <span>DEPÓSITO TRANSFERENCIA</span>
      </div>
      <div class="row m-0">
        <select v-model="bank" id="select-banks" class="form-control col-4 mr-4" required>
          <option v-for="i in BANKS" :key="i" :value="i">
            {{ i }}
          </option>
        </select>
        <input
          v-model="numbertransfer"
          @input="onSelect('transferencia', bank, numbertransfer)"
          type="text"
          class="form-control col-4"
          placeholder="Nro de operación"
        />
      </div>
    </button>
    <button
      type="button"
      @click.prevent="onSelect('yape')"
      class="list-group-item"
      :class="{ active: value.type === 'yape' }"
      :disabled="!couponFree"
      v-if="showYape"
    >
      <div class="d-flex mb-2">
        <i class="material-icons mr-2">
          {{ value.type === 'yape' ? 'radio_button_checked' : 'radio_button_unchecked' }}
        </i>
        <span>YAPE</span>
      </div>
    </button>
    <button
      type="button"
      @click.prevent="onSelect('qr-visa')"
      class="list-group-item"
      :class="{ active: value.type === 'qr-visa' }"
      :disabled="!couponFree"
      v-if="includesMethod('qr-visa')"
    >
      <div class="d-flex mb-2">
        <i class="material-icons mr-2">
          {{ value.type === 'qr-visa' ? 'radio_button_checked' : 'radio_button_unchecked' }}
        </i>
        <span>QRVISA</span>
      </div>
    </button>
    <button
      type="button"
      @click.prevent="onSelect('parts')"
      class="list-group-item"
      :class="{ active: value.type === 'parts' }"
      :disabled="!couponFree"
      v-if="includesMethod('parts')"
    >
      <div class="parts-headers">
        <div class="d-flex mb-2">
          <i class="material-icons mr-2">
            {{ value.type === 'parts' ? 'radio_button_checked' : 'radio_button_unchecked' }}
          </i>
          <span>PAGO EN PARTES</span>
        </div>
        <b-button variant="warning" class="mb-2 mr-2" @click="addPayParts()">
          <div class="d-flex">
            <i class="material-icons">add</i>
          </div>
        </b-button>
      </div>
      <div v-for="(elem, index) in arrayCodes" :key="index">
        <div class="parts-contents" :class="`parts-contents-${index}`">
          <select
            :id="`select-part-${index}`"
            type="text"
            class="form-control mr-2"
            v-model="elem.paymentMethod"
            required
          >
            <option v-for="pay in elem.methods" :value="pay" :key="pay">
              {{ pay }}
            </option>
          </select>
          <input
            :id="`input-part-amount-${index}`"
            v-model="elem.amount"
            type="text"
            class="form-control mr-2"
            placeholder="Cantidad"
          />
          <input
            :id="`input-part-reference-${index}`"
            v-model="elem.reference"
            type="text"
            class="form-control mr-2"
            placeholder="Código"
            :disabled="elem.paymentMethod === 'EFECTIVO'"
          />
          <b-button
            :id="`button-part-${index}`"
            variant="danger"
            class="mb-2"
            @click="deleteParts(elem.id)"
          >
            <div class="d-flex">
              <i class="material-icons">delete</i>
            </div>
          </b-button>
        </div>
      </div>
    </button>
    <button
      type="button"
      @click.prevent="onSelect('multiple')"
      class="list-group-item"
      :class="{ 'active rounded-0': value.type === 'multiple' }"
      v-if="includesMethod('multiple')"
      :disabled="!couponFree"
    >
      <div class="d-flex mb-2">
        <i class="material-icons mr-2">
          {{ value.type === 'multiple' ? 'radio_button_checked' : 'radio_button_unchecked' }}
        </i>
        <span>PAGO MIXTO</span>
      </div>
    </button>
    <div v-if="metaData">
      <div v-for="(item, index) in qrPayment" :key="index" class="list-group">
        <button
          type="button"
          @click.prevent="onSelect(item.paymentMethod)"
          class="list-group-item"
          :class="{ active: value.type === item.paymentMethod }"
          :disabled="!couponFree"
        >
          <div class="d-flex mb-2">
            <i class="material-icons mr-2">
              {{
                value.type === item.paymentMethod
                  ? 'radio_button_checked'
                  : 'radio_button_unchecked'
              }}
            </i>
            <span>{{ item.paymentMethod }}</span>
          </div>
        </button>
      </div>
      <ModalPaymentQR :image="itemPaymentQR.imageqr" :name="itemPaymentQR.paymentMethod" />
    </div>
  </div>
</template>

<script>
import { PAY_METHODS, CARD_TYPES, BANKS, DETAIL_PAYMENT } from '../consts';

export default {
  props: {
    value: {
      type: Object,
      default() {
        return {
          type: 'efectivo',
          card: null,
          code: null
        };
      }
    },
    couponFree: {
      type: Boolean,
      default() {
        return true;
      }
    },
    hideVisaqr: {
      type: Boolean,
      default() {
        return false;
      }
    },
    mixedShow: {
      type: Boolean,
      default() {
        return false;
      }
    },
    showYape: {
      type: Boolean,
      default() {
        return false;
      }
    },
    pointsAmount: {
      type: String,
      default() {
        return '';
      }
    },
    saleType: {
      type: String,
      default() {
        return 'ticket';
      }
    }
  },
  data() {
    return {
      PAY_METHODS,
      CARD_TYPES,
      BANKS,
      DETAIL_PAYMENT,
      typeCard: 'VISA',
      detailPayment: null,
      bank: 'BCP',
      numberPost: '',
      mastercard: '',
      showModalPayment: false,
      itemPaymentQR: '',
      numbertransfer: '',
      part: {
        id: '',
        paymentMethod: 'EFECTIVO',
        reference: '',
        amount: '',
        methods: PAY_METHODS
      },
      arrayCodes: [
        {
          id: Math.random().toString(36).substr(2, 18),
          paymentMethod: 'EFECTIVO',
          reference: '',
          amount: '',
          methods: PAY_METHODS
        }
      ]
    };
  },
  filters: {
    upperCase(value) {
      return value.toUpperCase();
    }
  },
  watch: {
    arrayCodes: {
      handler(value) {
        const data = {
          card: 'payments-parts',
          code: value,
          type: 'parts'
        };
        this.$emit('part-payment', data);
      },
      deep: true
    },
    existBrand(value) {
      this.detailPayment = value;
    }
  },
  created() {
    this.detailPayment = this.existBrand;
  },
  computed: {
    metaData() {
      return this.$store.getters.getMetadata;
    },
    qrPayment() {
      return this.metaData.qrPayment ? JSON.parse(this.metaData.qrPayment) : [];
    },
    paymentMethods() {
      let methods = this.metaData.payment_methods_billing;
      return methods ? methods.split(",") : [];
    },
    thereAreMethods() {
      if (!this.paymentMethods) return false;
      return this.paymentMethods.length !== 0 ? true : false;
    },
    existBrand() {
      return this.$store.getters.getBrandSelected;
    }
  },
  methods: {
    includesMethod(method) {
      let methods = [];
      const defaultMethods = ['efectivo', 'pos'];
      if (!this.thereAreMethods || this.saleType === 'ticket') {
        methods = defaultMethods;
      } else {
        methods = this.paymentMethods;
      }
      return methods.includes(method);
    },
    onSelect(type, card, code ,detailPayment) {
      if (type === 'YAPE' || type === 'PLIN') {
        this.itemPaymentQR = this.qrPayment.find((elem) => elem.paymentMethod === type);
      }
      this.$emit('input', { type, card, code, detailPayment });
    },
    addPayParts() {
      const part = { ...this.part };
      part.id = Math.random().toString(36).substr(2, 18);
      this.arrayCodes.push(part);
    },
    deleteParts(value) {
      const arrayParts = [...this.arrayCodes];
      const deletePart = arrayParts.filter((elem) => {
        return elem.id !== value;
      });
      this.arrayCodes = deletePart;
    },
    changePart(e, index) {
      const { value } = e.target;
      this.arrayCodes[index].paymentMethod = value;
    }
  }
};
</script>
<style lang="scss" scoped>
.parts-headers {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.parts-contents {
  display: flex;
  flex-direction: row;
  align-content: center;
}

.btn-dev {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  @media screen and (min-width: 48em) {
    flex-direction: row;
  }
  select {
    text-align: center;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
}
</style>